import React from 'react';

// Use public folder for better compatibility with production builds
const youCrmLogo = process.env.PUBLIC_URL + '/youcrm.svg';

interface LogoProps {
  className?: string;
  showCompanyName?: boolean;
  variant?: 'default' | 'modern' | 'compact';
}

const Logo: React.FC<LogoProps> = ({ 
  className, 
  showCompanyName = false, 
  variant = 'modern' 
}) => {
  if (variant === 'modern') {
    return (
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center">
          <img 
            src={youCrmLogo} 
            alt="YOUCRM Logo" 
            className={`${className} transition-all duration-300`} 
          />
        </div>
      </div>
    );
  }
  
  if (variant === 'compact') {
    return (
      <div className="flex items-center space-x-2">
        <img 
          src={youCrmLogo} 
          alt="YOUCRM Logo" 
          className={`${className} max-h-8`} 
        />
      </div>
    );
  }
  
  // Default variant
  return (
    <div className="flex flex-col items-center pt-1">
      <img 
        src={youCrmLogo} 
        alt="YOUCRM Logo" 
        className={className} 
      />
    </div>
  );
};

export default Logo; 